<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }"
            >首页</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/product_Management/publish/event_publish_management' }">赛事产品管理</el-breadcrumb-item>
        <el-breadcrumb-item>发布新赛季</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <div class="page-title">{{ seasonName }}个人赛</div>
    <div class="page-current">当前阶段：{{ currentTabObj.scheduleFlagName }}</div>
    <div class="progress-steps-row">
        <div
        v-for="(step, index) in steps"
        :key="index"
        @click="changStepFn(step, index)"
        class="step-col"
        :class="{
            'step-choose': chooseIndex === index,
            'step-finish': currentIndex > index,
            'step-current': currentIndex === index,
            'step-pending': currentIndex < index
        }"
        >
            <div class="step-inner" :class="{first: index === 0, last: index === steps.length - 1}">
                <div class="step-title">
                  <i v-if="currentIndex > index" class="el-icon-success"></i>
                  <i v-if="currentIndex === index" class="el-icon-upload"></i>
                  {{ step.scheduleFlagName }}
                </div>
                <!-- <div class="step-desc">{{ step.desc }}</div> -->
                <div class="step-date">{{ step.date || '未开始' }}</div>
            </div>
        </div>
    </div>
    <div class="start-btn" v-if="chooseIndex === currentIndex + 1" @click="scheduleStartFn"><i class="el-icon-thumb"></i>启动</div>
    <el-row :gutter="15">
      <el-col :span="18">
        <!-- 赛季发布 -->
        <el-card class="card" v-if="chooseIndex === 0" style="margin-bottom: 15px;">
          <div class="dept-name">赛季启动</div>
          <div class="tip">时间：{{ startTime }}</div>
          <div class="schedule" style="padding: 20px;">
            <!-- :model="scheduleList"  -->
            <el-form ref="form" label-width="100px">
              <el-row :gutter="20">
                <el-col :span="12" v-for="(item, index) in scheduleList" :key="index">
                  <div class="schedule-title">
                    <div class="tit">{{ item.scheduleFlagName }}</div>
                  </div>
                  <el-form-item label="时间周期">
                    <el-date-picker
                      style="width: 100%"
                      type="monthrange"
                      format="yyyy年M月"
                      value-format="yyyy-MM"
                      range-separator="至"
                      start-placeholder="开始月份"
                      end-placeholder="结束月份"
                      placeholder="请选择月份区间"
                      clearable
                      :value="[item.beginTime, item.endTime]"
                      @input="val => { item.beginTime = (val && val[0]) || ''; item.endTime = (val && val[1]) || '' }"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="定价">
                    <el-input v-model="item.price" placeholder="请输入定价"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <el-button class="save-btn" type="success" size="small" icon="el-icon-check" @click="updateStartSchedule">保存</el-button>
          </div>
        </el-card>
        <el-card class="card" v-for="(deptItem, index) in deptSection" :key="index">
          <!-- 部门标题 -->
          <!-- <el-row class="title_row">
            <el-col :span="12">
              <span class="title_class">{{ deptItem.name }}</span>
            </el-col>
          </el-row> -->
          <div class="dept-name">{{ deptItem.name }}</div>
          <div style="padding: 20px;">
          <!-- *** -->
          <!-- 新赛季启动 -->
          <!-- *** -->
          <template v-if="chooseIndex === 0">
            <!-- 0 - 设计部 -->
            <template v-if="deptItem.wildcard === 'SJB'">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />
              <el-form ref="form" :model="form" label-width="80px">
                <el-row :gutter="20">
                  <el-col :span="20">
                    <el-form-item label="Slogan">
                      <el-input v-model="form.slogan"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="LOGO">
                      <el-upload
                        class="upload-demo"
                        :action="uploadFile.uploadUrl"
                        :headers="uploadFile.headerObj"
                        :data="{ filePath: 'spbcn/spbcnappneed/crm/1/' }"
                        :show-file-list="false"
                        :on-success="(res, file, fileList) => onUploadSuccess(res, 'logo')"
                        :before-upload="beforeAvatarUpload"
                        multiple>
                        <i class="el-icon-plus"></i>
                      </el-upload>
                      <div class="img-list">
                        <div class="img-item" v-for="(url, idx) in uploadFiles.logo" :key="idx">
                          <img :src="url" class="img-thumb">
                          <div class="img-mask">
                            <i class="el-icon-download" title="下载" @click="downloadFile(url)"></i>
                            <i class="el-icon-zoom-in" title="预览" @click="previewImage(url)"></i>
                            <i class="el-icon-delete" title="删除" @click="removeFile(url, 'logo')"></i>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="海报">
                      <el-upload
                        class="upload-demo"
                        :action="uploadFile.uploadUrl"
                        :headers="uploadFile.headerObj"
                        :data="{ filePath: 'spbcn/spbcnappneed/crm/1/' }"
                        :show-file-list="false"
                        :on-success="(res, file, fileList) => onUploadSuccess(res, 'poster')"
                        :before-upload="beforeAvatarUpload"
                        multiple>
                        <i class="el-icon-plus"></i>
                      </el-upload>
                      <div class="img-list">
                        <div class="img-item" v-for="(url, idx) in uploadFiles.poster" :key="idx">
                          <img :src="url" class="img-thumb">
                          <div class="img-mask">
                            <i class="el-icon-download" title="下载" @click="downloadFile(url)"></i>
                            <i class="el-icon-zoom-in" title="预览" @click="previewImage(url)"></i>
                            <i class="el-icon-delete" title="删除" @click="removeFile(url, 'poster')"></i>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="天头地尾">
                      <el-upload
                        class="upload-demo"
                        :action="uploadFile.uploadUrl"
                        :headers="uploadFile.headerObj"
                        :data="{ filePath: 'spbcn/spbcnappneed/crm/1/' }"
                        :show-file-list="false"
                        :on-success="(res, file, fileList) => onUploadSuccess(res, 'docxTemplate')"
                        :before-upload="beforeAvatarUpload"
                        multiple>
                        <i class="el-icon-plus"></i>
                      </el-upload>
                      <div class="img-list">
                        <div class="img-item" v-for="(url, idx) in uploadFiles.docxTemplate" :key="idx">
                          <img :src="url" class="img-thumb">
                          <div class="img-mask">
                            <i class="el-icon-download" title="下载" @click="downloadFile(url)"></i>
                            <i class="el-icon-zoom-in" title="预览" @click="previewImage(url)"></i>
                            <i class="el-icon-delete" title="删除" @click="removeFile(url, 'docxTemplate')"></i>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="PPT模板">
                      <el-upload
                        class="upload-file"
                        :action="uploadFile.uploadUrl"
                        :headers="uploadFile.headerObj"
                        :data="{ filePath: 'spbcn/spbcnappneed/crm/1/' }"
                        :show-file-list="false"
                        :on-success="(res, file, fileList) => onUploadSuccess(res, 'pptTemplate')"
                        multiple>
                        <el-button size="small" plain type="primary">点击上传</el-button>
                      </el-upload>
                      <div class="file-list">
                        <div class="file-item" v-for="(url, idx) in uploadFiles.pptTemplate" :key="idx" @click="downloadFile(url)">
                          <i class="el-icon-document"></i>
                          <span class="file-name">PPT模板 {{ idx + 1 }}</span>
                          <i class="el-icon-download"></i>
                          <i class="el-icon-delete" @click.stop="removeFile(url, 'pptTemplate')"></i>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <el-button class="save-btn" type="primary" size="small" icon="el-icon-check" @click="updateStartSj">确认提交</el-button>
            </template>
            <!-- 0 - 科技部 -->
            <template v-if="deptItem.wildcard === 'FYKJ'">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />
              <el-form ref="form" :model="form" label-width="120px">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="考量申请功能">
                    <el-checkbox
                      :true-label="1"
                      :false-label="0"
                      v-model="supplementInfo[deptItem.id].finishState"
                      label="完成"
                      border
                    ></el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <el-button class="save-btn" type="primary" size="small" icon="el-icon-check" @click="updateStartKj">确认提交</el-button>

            </template>
            <!-- 0 - 交付中心 -->
            <template v-if="deptItem.wildcard === 'JFZX'">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />
              <el-form ref="form" :model="form" label-width="120px">
                <el-row :gutter="20">
                  <el-col :span="20">
                    <el-form-item label="进校文件">
                      <el-upload
                        class="upload-file"
                        :action="uploadFile.uploadUrl"
                        :headers="uploadFile.headerObj"
                        :data="{ filePath: 'spbcn/spbcnappneed/crm/2/' }"
                        :show-file-list="false"
                        :on-success="(res, file, fileList) => onUploadSuccess(res, 'entryDocuments')"
                        multiple>
                        <el-button size="small" plain type="primary">点击上传</el-button>
                      </el-upload>
                      <div class="file-list">
                        <div class="file-item" v-for="(url, idx) in uploadFiles.entryDocuments" :key="idx" @click="downloadFile(url)">
                          <i class="el-icon-document"></i>
                          <span class="file-name">进校文件 {{ idx + 1 }}</span>
                          <i class="el-icon-download"></i>
                          <i class="el-icon-delete" @click.stop="removeFile(url, 'entryDocuments')"></i>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <el-button class="save-btn" type="primary" size="small" icon="el-icon-check" @click="updateStartXx">确认提交</el-button>
            </template>
          </template>
          <!-- *** -->
          <!-- 初选 -->
          <!-- *** -->
          <template v-if="chooseIndex === 1">
            <!-- 1 - 学术 -->
            <template v-if="deptItem.wildcard === 'XSB'">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />
              <el-form ref="form" :model="form" label-width="120px">
                <el-row :gutter="20">
                  <el-col :span="10">
                    <el-form-item label="初赛试卷">
                      <!-- <el-input v-model="form.name"></el-input> -->
                      <!-- TODO: 上传 filePath 与提交接口/传参待后端确认 -->
                      <el-upload
                        class="upload-file"
                        :action="uploadFile.uploadUrl"
                        :headers="uploadFile.headerObj"
                        :data="{ filePath: '' }"
                        :show-file-list="false"
                        :on-success="(res, file, fileList) => onUploadSuccess(res, 'preliminaryPaper')"
                        multiple>
                        <el-button size="small" plain type="primary">点击上传</el-button>
                      </el-upload>
                      <div class="file-list">
                        <div class="file-item" v-for="(url, idx) in uploadFiles.preliminaryPaper" :key="idx" @click="downloadFile(url)">
                          <i class="el-icon-document"></i>
                          <span class="file-name">初赛试卷 {{ idx + 1 }}</span>
                          <i class="el-icon-download"></i>
                          <i class="el-icon-delete" @click.stop="removeFile(url, 'preliminaryPaper')"></i>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="初赛音频">
                      <!-- <el-input v-model="form.name"></el-input> -->
                      <!-- TODO: 上传 filePath 与提交接口/传参待后端确认 -->
                      <el-upload
                        class="upload-file"
                        :action="uploadFile.uploadUrl"
                        :headers="uploadFile.headerObj"
                        :data="{ filePath: '' }"
                        :show-file-list="false"
                        :on-success="(res, file, fileList) => onUploadSuccess(res, 'preliminaryAudio')"
                        multiple>
                        <el-button size="small" plain type="primary">点击上传</el-button>
                      </el-upload>
                      <div class="file-list">
                        <div class="file-item" v-for="(url, idx) in uploadFiles.preliminaryAudio" :key="idx" @click="downloadFile(url)">
                          <i class="el-icon-document"></i>
                          <span class="file-name">初赛音频 {{ idx + 1 }}</span>
                          <i class="el-icon-download"></i>
                          <i class="el-icon-delete" @click.stop="removeFile(url, 'preliminaryAudio')"></i>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <el-button class="save-btn" @click="updateStartYyxs1" type="primary" size="small" icon="el-icon-check">确认提交</el-button>
            </template>
            <!-- 1 - 科技 -->
            <template v-if="deptItem.wildcard === 'FYKJ' && chooseIndex === 1">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />
              <el-form ref="form" :model="form" label-width="120px">
                <el-form-item label="线上初赛系统">
                  <el-checkbox
                    v-model="supplementInfo[deptItem.id].finishState"
                    :true-label="1"
                    :false-label="0"
                    label="完成"
                    border
                  ></el-checkbox>
                </el-form-item>
              </el-form>
              <el-button class="save-btn" type="primary" size="small" icon="el-icon-check" @click="updatePreliminaryKj">确认提交</el-button>
            </template>
            <!-- 1 - 设计 -->
            <template v-if="deptItem.wildcard === 'SJB' && chooseIndex === 1">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />
              <el-form ref="form" :model="form" label-width="120px">
                <el-row :gutter="20">
                  <el-col :span="20">
                    <el-form-item label="试卷模板">
                      <!-- <el-input v-model="form.name"></el-input> -->
                      <!-- TODO: 上传 filePath 与提交接口/传参待后端确认 -->
                      <el-upload
                        class="upload-file"
                        :action="uploadFile.uploadUrl"
                        :headers="uploadFile.headerObj"
                        :data="{ filePath: '' }"
                        :show-file-list="false"
                        :on-success="(res, file, fileList) => onUploadSuccess(res, 'preliminaryPaperTemplate')"
                        multiple>
                        <el-button size="small" plain type="primary">点击上传</el-button>
                      </el-upload>
                      <div class="file-list">
                        <div class="file-item" v-for="(url, idx) in uploadFiles.preliminaryPaperTemplate" :key="idx" @click="downloadFile(url)">
                          <i class="el-icon-document"></i>
                          <span class="file-name">试卷模板 {{ idx + 1 }}</span>
                          <i class="el-icon-download"></i>
                          <i class="el-icon-delete" @click.stop="removeFile(url, 'preliminaryPaperTemplate')"></i>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <el-button class="save-btn" @click="updateStartSjb1" type="primary" size="small" icon="el-icon-check">确认提交</el-button>
            </template>
            <!-- 1 - 交付 -->
            <template v-if="deptItem.wildcard === 'JFZX' && chooseIndex === 1">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />
              <el-form ref="form" :model="form" label-width="120px">
                <el-row :gutter="20">
                  <el-col :span="20">
                    <el-form-item label="项目手册文案">
                      <el-upload
                        class="upload-file"
                        :action="uploadFile.uploadUrl"
                        :headers="uploadFile.headerObj"
                        :data="{ filePath: 'spbcn/spbcnappneed/crm/2/' }"
                        :show-file-list="false"
                        :on-success="(res, file, fileList) => onUploadSuccess(res, 'preliminaryManual')"
                        multiple>
                        <el-button size="small" plain type="primary">点击上传</el-button>
                      </el-upload>
                      <div class="file-list">
                        <div class="file-item" v-for="(url, idx) in uploadFiles.preliminaryManual" :key="idx" @click="downloadFile(url)">
                          <i class="el-icon-document"></i>
                          <span class="file-name">项目手册文案 {{ idx + 1 }}</span>
                          <i class="el-icon-download"></i>
                          <i class="el-icon-delete" @click.stop="removeFile(url, 'preliminaryManual')"></i>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <el-button class="save-btn" type="primary" size="small" icon="el-icon-check" @click="updatePreliminaryJfzx">确认提交</el-button>
            </template>
          </template>

          <!-- *** -->
          <!-- 复选 -->
          <!-- *** -->
          <template v-if="chooseIndex === 2">
            <!-- 1 - 学术 -->
            <template v-if="deptItem.wildcard === 'XSB'">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />
              <el-form ref="form" :model="form" label-width="120px">
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="词库校对">
                      <el-checkbox v-model="checked1" label="完成" border></el-checkbox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="复赛试卷">
                      <!-- <el-input v-model="form.name"></el-input> -->
                      <!-- TODO: 上传 filePath 与提交接口/传参待后端确认 -->
                      <el-upload
                        class="upload-file"
                        :action="uploadFile.uploadUrl"
                        :headers="uploadFile.headerObj"
                        :data="{ filePath: '' }"
                        :show-file-list="false"
                        :on-success="(res, file, fileList) => onUploadSuccess(res, 'yyxsrematchExam')"
                        multiple>
                        <el-button size="small" plain type="primary">点击上传</el-button>
                      </el-upload>
                      <div class="file-list">
                        <div class="file-item" v-for="(url, idx) in uploadFiles.yyxsrematchExam" :key="idx" @click="downloadFile(url)">
                          <i class="el-icon-document"></i>
                          <span class="file-name">复赛试卷 {{ idx + 1 }}</span>
                          <i class="el-icon-download"></i>
                          <i class="el-icon-delete" @click.stop="removeFile(url, 'yyxsrematchExam')"></i>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="裁判纸">
                      <!-- <el-input v-model="form.name"></el-input> -->
                      <!-- TODO: 上传 filePath 与提交接口/传参待后端确认 -->
                      <el-upload
                        class="upload-file"
                        :action="uploadFile.uploadUrl"
                        :headers="uploadFile.headerObj"
                        :data="{ filePath: '' }"
                        :show-file-list="false"
                        :on-success="(res, file, fileList) => onUploadSuccess(res, 'yyxsrefereePaper')"
                        multiple>
                        <el-button size="small" plain type="primary">点击上传</el-button>
                      </el-upload>
                      <div class="file-list">
                        <div class="file-item" v-for="(url, idx) in uploadFiles.yyxsrefereePaper" :key="idx" @click="downloadFile(url)">
                          <i class="el-icon-document"></i>
                          <span class="file-name">裁判纸 {{ idx + 1 }}</span>
                          <i class="el-icon-download"></i>
                          <i class="el-icon-delete" @click.stop="removeFile(url, 'yyxsrefereePaper')"></i>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <el-button class="save-btn" @click="updateStartYyxs2" type="primary" size="small" icon="el-icon-check">确认提交</el-button>
            </template>
            <!-- 1 - 科技 -->
            <template v-if="deptItem.wildcard === 'FYKJ'">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />
              <el-form ref="form" :model="form" label-width="120px">
                <el-row>
                  <el-col :span="6">
                    <el-form-item label="初转复系统">
                      <el-checkbox v-model="checked1" label="完成" border></el-checkbox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="更新词库">
                      <el-checkbox v-model="checked1" label="完成" border></el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <el-button class="save-btn" type="primary" size="small" icon="el-icon-check">确认提交</el-button>
            </template>
            <!-- 1 - 设计 -->
            <template v-if="deptItem.wildcard === 'SJB'">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />
              <el-form ref="form" :model="form" label-width="120px">
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="试卷模板">
                      <!-- <el-input v-model="form.name"></el-input> -->
                      <!-- TODO: 上传 filePath 与提交接口/传参待后端确认 -->
                      <el-upload
                        class="upload-file"
                        :action="uploadFile.uploadUrl"
                        :headers="uploadFile.headerObj"
                        :data="{ filePath: '' }"
                        :show-file-list="false"
                        :on-success="(res, file, fileList) => onUploadSuccess(res, 'sjbrematchTemplate')"
                        multiple>
                        <el-button size="small" plain type="primary">点击上传</el-button>
                      </el-upload>
                      <div class="file-list">
                        <div class="file-item" v-for="(url, idx) in uploadFiles.sjbrematchTemplate" :key="idx" @click="downloadFile(url)">
                          <i class="el-icon-document"></i>
                          <span class="file-name">试卷模板 {{ idx + 1 }}</span>
                          <i class="el-icon-download"></i>
                          <i class="el-icon-delete" @click.stop="removeFile(url, 'sjbrematchTemplate')"></i>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="手册设计">
                      <el-checkbox v-model="checked1" label="完成" border></el-checkbox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="主视觉">
                      <el-checkbox v-model="checked1" label="完成" border></el-checkbox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="场布">
                      <el-checkbox v-model="checked1" label="完成" border></el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <el-button class="save-btn" @click="updateStartSjb2" type="primary" size="small" icon="el-icon-check">确认提交</el-button>
            </template>
            <!-- 1 - 交付 -->
            <template v-if="deptItem.wildcard === 'JFZX'">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />

            </template>
          </template>

          <!-- *** -->
          <!-- 城市/网络选 -->
          <!-- *** -->
          <template v-if="chooseIndex === 3">
            <!-- 1 - 学术 -->
            <template v-if="deptItem.wildcard === 'XSB'">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />
              <el-form ref="form" :model="form" label-width="120px">
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="城市赛考题">
                      <!-- <el-input v-model="form.name"></el-input> -->
                      <!-- TODO: 上传 filePath 与提交接口/传参待后端确认 -->
                      <el-upload
                        class="upload-file"
                        :action="uploadFile.uploadUrl"
                        :headers="uploadFile.headerObj"
                        :data="{ filePath: '' }"
                        :show-file-list="false"
                        :on-success="(res, file, fileList) => onUploadSuccess(res, 'yyxscityExam')"
                        multiple>
                        <el-button size="small" plain type="primary">点击上传</el-button>
                      </el-upload>
                      <div class="file-list">
                        <div class="file-item" v-for="(url, idx) in uploadFiles.yyxscityExam" :key="idx" @click="downloadFile(url)">
                          <i class="el-icon-document"></i>
                          <span class="file-name">城市赛考题 {{ idx + 1 }}</span>
                          <i class="el-icon-download"></i>
                          <i class="el-icon-delete" @click.stop="removeFile(url, 'yyxscityExam')"></i>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <el-button class="save-btn" @click="updateStartYyxs3" type="primary" size="small" icon="el-icon-check">确认提交</el-button>
            </template>
            <!-- 1 - 科技 -->
            <template v-if="deptItem.wildcard === 'FYKJ'">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />
              <el-form ref="form" :model="form" label-width="120px">
                <el-col :span="6">
                  <el-form-item label="国赛缴费系统">
                    <el-checkbox v-model="checked1" label="完成" border></el-checkbox>
                  </el-form-item>
                </el-col>
              </el-form>
              <el-button class="save-btn" type="primary" size="small" icon="el-icon-check">确认提交</el-button>
            </template>
            <!-- 1 - 设计 -->
            <template v-if="deptItem.wildcard === 'SJB'">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />
              <el-form ref="form" :model="form" label-width="120px">
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="上传备品">
                      <!-- <el-input v-model="form.name"></el-input> -->
                      <!-- TODO: 上传 filePath 与提交接口/传参待后端确认 -->
                      <el-upload
                        class="upload-file"
                        :action="uploadFile.uploadUrl"
                        :headers="uploadFile.headerObj"
                        :data="{ filePath: '' }"
                        :show-file-list="false"
                        :on-success="(res, file, fileList) => onUploadSuccess(res, 'sjbcitySpare')"
                        multiple>
                        <el-button size="small" plain type="primary">点击上传</el-button>
                      </el-upload>
                      <div class="file-list">
                        <div class="file-item" v-for="(url, idx) in uploadFiles.sjbcitySpare" :key="idx" @click="downloadFile(url)">
                          <i class="el-icon-document"></i>
                          <span class="file-name">上传备品 {{ idx + 1 }}</span>
                          <i class="el-icon-download"></i>
                          <i class="el-icon-delete" @click.stop="removeFile(url, 'sjbcitySpare')"></i>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <el-button class="save-btn" @click="updateStartSjb3" type="primary" size="small" icon="el-icon-check">确认提交</el-button>
            </template>
            <!-- 1 - 交付 -->
            <template v-if="deptItem.wildcard === 'JFZX'">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />

            </template>
          </template>

          <!-- *** -->
          <!-- 全国总决选 -->
          <!-- *** -->
          <template v-if="chooseIndex === 4">
            <!-- 1 - 学术 -->
            <template v-if="deptItem.wildcard === 'XSB'">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />
              <el-form ref="form" :model="form" label-width="120px">
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="上传考题">
                      <!-- <el-input v-model="form.name"></el-input> -->
                      <!-- TODO: 上传 filePath 与提交接口/传参待后端确认 -->
                      <el-upload
                        class="upload-file"
                        :action="uploadFile.uploadUrl"
                        :headers="uploadFile.headerObj"
                        :data="{ filePath: '' }"
                        :show-file-list="false"
                        :on-success="(res, file, fileList) => onUploadSuccess(res, 'yyxsfinalsExam')"
                        multiple>
                        <el-button size="small" plain type="primary">点击上传</el-button>
                      </el-upload>
                      <div class="file-list">
                        <div class="file-item" v-for="(url, idx) in uploadFiles.yyxsfinalsExam" :key="idx" @click="downloadFile(url)">
                          <i class="el-icon-document"></i>
                          <span class="file-name">上传考题 {{ idx + 1 }}</span>
                          <i class="el-icon-download"></i>
                          <i class="el-icon-delete" @click.stop="removeFile(url, 'yyxsfinalsExam')"></i>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <el-button class="save-btn" @click="updateStartYyxs4" type="primary" size="small" icon="el-icon-check">确认提交</el-button>
            </template>
            <!-- 1 - 科技 -->
            <template v-if="deptItem.wildcard === 'FYKJ'">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />
              <el-form ref="form" :model="form" label-width="120px">
                <el-col :span="6">
                  <el-form-item label="国赛系统">
                    <el-checkbox v-model="checked1" label="完成" border></el-checkbox>
                  </el-form-item>
                </el-col>
              </el-form>
              <el-button class="save-btn" type="primary" size="small" icon="el-icon-check">确认提交</el-button>
            </template>
            <!-- 1 - 设计 -->
            <template v-if="deptItem.wildcard === 'SJB'">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />
              <el-form ref="form" :model="form" label-width="120px">
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-form-item label="上传备品">
                      <!-- <el-input v-model="form.name"></el-input> -->
                      <!-- TODO: 上传 filePath 与提交接口/传参待后端确认 -->
                      <el-upload
                        class="upload-file"
                        :action="uploadFile.uploadUrl"
                        :headers="uploadFile.headerObj"
                        :data="{ filePath: '' }"
                        :show-file-list="false"
                        :on-success="(res, file, fileList) => onUploadSuccess(res, 'sjbfinalsSpare')"
                        multiple>
                        <el-button size="small" plain type="primary">点击上传</el-button>
                      </el-upload>
                      <div class="file-list">
                        <div class="file-item" v-for="(url, idx) in uploadFiles.sjbfinalsSpare" :key="idx" @click="downloadFile(url)">
                          <i class="el-icon-document"></i>
                          <span class="file-name">上传备品 {{ idx + 1 }}</span>
                          <i class="el-icon-download"></i>
                          <i class="el-icon-delete" @click.stop="removeFile(url, 'sjbfinalsSpare')"></i>
                        </div>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <el-button class="save-btn" @click="updateStartSjb4" type="primary" size="small" icon="el-icon-check">确认提交</el-button>
            </template>
            <!-- 1 - 交付 -->
            <template v-if="deptItem.wildcard === 'JFZX'">
              <moduleHeader :schedule-flag="scheduleFlag" :dept-id="deptItem.id" :season-id="id" :value="supplementInfo[deptItem.id]" @submit="handleModuleChange" />

            </template>
          </template>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <el-row class="title_row">
            <el-col :span="12">
              <span class="title_class">发布记录</span>
            </el-col>
          </el-row>
          <el-empty v-if="!timelineData.length" description="暂无操作记录" :image-size="60"></el-empty>
          <div class="time-line">
            <div class="time-line-item" v-for="(item, index) in timelineData" :key="index">
              <div class="time-dot"></div>
              <div class="time-content">
                <div class="time-s">{{ item.scheduleName }}</div>
                <div class="time-date">{{ item.createTime }}</div>
                <div class="time-dept" v-if="item.deptName">{{ item.deptName }}</div>
                <div class="time-event">{{ item.remark }}</div>
                <div class="time-person">操作：{{ item.operationName }}</div>

              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!-- 图片预览大图 -->
    <el-dialog :visible.sync="previewVisible" width="70%" title="图片预览" append-to-body custom-class="img-preview-dialog">
      <img :src="previewUrl" style="width: 100%; display: block;" />
    </el-dialog>
  </div>
</template>
<script>
import moduleHeader from './event/moduleHeader.vue'

export default {
  components: {
    moduleHeader
  },
  data () {
    return {
      id: this.$route.query.id,
      seasonName: this.$route.query.name,
      form: {
        slogan: '' // 设计部 Slogan，预先声明以保证响应式（避免 Vue 2 无法检测新增属性）
      },
      // 各模块的截止日期/部门/负责人数据，key 为 moduleKey
      moduleData: {},
      chooseIndex: 0,
      chooseFlag: '',
      currentIndex: 0,
      currentTabObj: {},
      timelineData: [],
      steps: [], // 顶部tabbar
      scheduleList: [],
      startTime: '',
      checked1: false,
      deptSection: [], // 部门待办模块
      scheduleFlag: '',
      supplementInfo: {}, // 按部门存储已填信息 { [deptId]: { deadlineTime, personId, finishState, id } }
      // 设计部上传文件链接数组（每个字段可上传多个，存文件链接字符串）
      uploadFiles: {
        logo: [], // LOGO 图片链接数组
        poster: [], // 海报 图片链接数组
        docxTemplate: [], // 天头地尾 图片链接数组
        pptTemplate: [], // PPT模板 文件链接数组
        entryDocuments: [], // 交付中心-进校文件 链接数组
        preliminaryManual: [], // 交付中心-项目手册文案 链接数组
        preliminaryPaper: [], // 学术-初赛试卷
        yyxsrematchExam: [], // 学术-复赛试卷
        yyxsrefereePaper: [], // 学术-裁判纸
        yyxscityExam: [], // 学术-城市赛考题
        yyxsfinalsExam: [], // 学术-总决选上传考题
        preliminaryAudio: [], // 学术-初赛音频
        preliminaryPaperTemplate: [], // 设计-初选试卷模板
        sjbrematchTemplate: [], // 设计-复选试卷模板
        sjbcitySpare: [], // 设计-城市上传备品
        sjbfinalsSpare: [] // 设计-总决选上传备品
      },
      previewVisible: false, // 图片预览对话框显隐
      previewUrl: '', // 预览大图链接
      uploadFile: {
        uploadUrl: this.$http.defaults.baseURL + 'upload/uploadFileAliOss',
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        }
      }
    }
  },
  created () {
    this.getTabList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    handleModuleChange () {
      this.getTimeLine()
    },
    getTimeLine () {
      const params = {
        id: this.id,
        flag: this.chooseFlag
      }
      this.$http.get('seasonProduct/timeline', { params }).then(res => {
        if (res.code === 200) {
          this.timelineData = res.data
        }
      })
    },
    getTabList () {
      this.$http.get('seasonProduct/selectScheduleBySeason?id=' + this.id).then(res => {
        if (res.code === 200) {
          res.data.forEach((item, index) => {
            item.date = index === 0 ? item.beginTime : `${item.beginTime} ~ ${item.endTime}`
          })
          this.steps = res.data
          this.startTime = res.data[0].beginTime
          this.scheduleList = (res.data || []).filter((item, index) => index !== 0).map(item => ({
            beginTime: item.beginTime || '',
            endTime: item.endTime || '',
            id: item.id || '',
            price: item.price || '',
            scheduleFlagName: item.scheduleFlagName
          }))
          this.currentIndex = res.data.findIndex(item => item.starting)
          this.chooseIndex = this.currentIndex
          this.currentTabObj = res.data.find(item => item.starting)
          const flag = res.data.find(item => item.starting).scheduleFlag
          this.getDept(flag)
          if (flag === 'START') {
            this.selectStartInfo()
          }
          this.chooseFlag = this.steps[this.chooseIndex].scheduleFlag
          this.getTimeLine()
        }
      })
    },
    getDept (flag) {
      this.scheduleFlag = flag
      this.$http.get('seasonProduct/deptList?code=' + flag).then(res => {
        if (res.code) {
          this.deptSection = res.data
          this.deptSection.forEach(item => {
            this.selectSupplementInfo(item.id)
          })
        }
      })
    },
    changStepFn (item, index) {
      this.chooseIndex = index
      // 切换赛段先清空各模块补充信息，避免未设置的截止日期/负责人选择器残留上一赛段内容
      // 清空后子组件（moduleHeader）收到的 value 为 undefined，触发其 resetForm 清空选择器
      this.supplementInfo = {}
      this.getDept(item.scheduleFlag)
      this.chooseFlag = item.scheduleFlag
      this.getTimeLine()
      if (item.scheduleFlag === 'START') {
        this.selectStartInfo()
      }
    },
    /**
     * 保存赛程信息
     */
    updateStartSchedule () {
      this.$http.post('seasonProduct/updateStartSchedule', this.scheduleList).then(res => {
        if (res.code === 200) {
          this.$message.success('保存成功')
          this.getTimeLine()
        }
      })
    },

    /**
     * 获取设计部详情（Slogan / LOGO / 海报 / 天头地尾 / PPT模板）
     * 后端返回 logo/poster/docxTemplate/pptTemplate 为 JSON 字符串数组，解析后回填 uploadFiles
     */
    selectStartInfo () {
      this.$http.get('seasonProduct/selectStartInfo?id=' + this.id).then(res => {
        if (res.code === 200 && res.data) {
          const d = res.data
          this.$set(this.form, 'slogan', d.slogan || '')
          this.uploadFiles.logo = this.parseFileArr(d.logo)
          this.uploadFiles.poster = this.parseFileArr(d.poster)
          this.uploadFiles.docxTemplate = this.parseFileArr(d.docxTemplate)
          this.uploadFiles.pptTemplate = this.parseFileArr(d.pptTemplate)
          // 交付中心
          this.uploadFiles.entryDocuments = this.parseFileArr(d.entryDocuments)
        }
      })
    },
    /**
     * 安全解析文件链接：兼容后端返回数组 / JSON 字符串 / 单个字符串 / 空
     */
    parseFileArr (val) {
      if (Array.isArray(val)) return val
      if (typeof val === 'string') {
        if (!val) return []
        try {
          const arr = JSON.parse(val)
          return Array.isArray(arr) ? arr : [val]
        } catch (e) {
          return [val]
        }
      }
      return []
    },
    /**
     * 获取当前赛段详情
     */
    selectSupplementInfo (deptId) {
      const params = {
        deptId,
        scheduleFlag: this.scheduleFlag,
        seasonProductId: this.id
      }
      this.$http.get('seasonProduct/selectSupplementInfo', { params }).then(res => {
        if (res.code === 200 && res.data) {
          const d = res.data
          const wildcard = (this.deptSection.find(dept => dept.id === deptId) || {}).wildcard

          // 接口返回的数据按 deptId 存储到 supplementInfo（含主键 id）
          this.$set(this.supplementInfo, deptId, {
            id: d.id || '',
            deadlineTime: d.deadlineTime || '',
            personId: d.personId || '',
            finishState: d.finishState || 0
          })
          // 各部门上传文件回填（统一由 selectSupplementInfo 按 deptId 回显）
          if (wildcard === 'XSB') {
            // 初选：初赛试卷 + 初赛音频
            this.uploadFiles.preliminaryPaper = this.parseFileArr(d.preliminaryPaper)
            this.uploadFiles.preliminaryAudio = this.parseFileArr(d.preliminaryAudio)
            // 复选：复赛试卷 + 裁判纸
            this.uploadFiles.yyxsrematchExam = this.parseFileArr(d.yyxsrematchExam)
            this.uploadFiles.yyxsrefereePaper = this.parseFileArr(d.yyxsrefereePaper)
            // 城市/网络选：城市赛考题
            this.uploadFiles.yyxscityExam = this.parseFileArr(d.yyxscityExam)
            // 全国总决选：上传考题
            this.uploadFiles.yyxsfinalsExam = this.parseFileArr(d.yyxsfinalsExam)
          } else if (wildcard === 'SJB') {
            // 初选：试卷模板
            this.uploadFiles.preliminaryPaperTemplate = this.parseFileArr(d.preliminaryPaperTemplate)
            // 复选：试卷模板
            this.uploadFiles.sjbrematchTemplate = this.parseFileArr(d.sjbrematchTemplate)
            // 城市/网络选：上传备品
            this.uploadFiles.sjbcitySpare = this.parseFileArr(d.sjbcitySpare)
            // 全国总决选：上传备品
            this.uploadFiles.sjbfinalsSpare = this.parseFileArr(d.sjbfinalsSpare)
          } else if (wildcard === 'JFZX') {
            // 交付中心：进校文件
            // this.uploadFiles.entryDocuments = this.parseFileArr(d.entryDocuments)
            // 交付中心：城市初选项目手册文案
            this.uploadFiles.preliminaryManual = this.parseFileArr(d.preliminaryManual)
          }
        }
      })
    },

    /**
     * 科技部：考量申请功能 - 确认提交
     * finishState: 0-未勾选 1-勾选（取 selectSupplementInfo 返回值）
     * id: selectSupplementInfo 当前部门返回的主键 id
     */
    updateStartKj () {
      const kjDeptId = (this.deptSection.find(d => d.wildcard === 'FYKJ') || {}).id
      const info = this.supplementInfo[kjDeptId]
      if (!info || !info.id) {
        this.$message.warning('数据未加载，请稍后重试')
        return
      }
      this.$http.post('seasonProduct/updateStartKj', {
        id: info.id,
        finishState: info.finishState || 0
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('提交成功')
          this.getTimeLine()
        } else {
          this.$message.error((res && res.msg) || '提交失败')
        }
      }).catch(() => {
        this.$message.error('提交失败')
      })
    },

    /**
     * 科技部：城市初选 - 线上初赛系统
     * 接口：seasonProduct/updatePreliminaryKJ
     * finishState: 0-未勾选 1-勾选
     * id: selectSupplementInfo 当前部门返回的主键 id
     */
    updatePreliminaryKj () {
      const kjDeptId = (this.deptSection.find(d => d.wildcard === 'FYKJ') || {}).id
      const info = this.supplementInfo[kjDeptId]
      if (!info || !info.id) {
        this.$message.warning('数据未加载，请稍后重试')
        return
      }
      this.$http.post('seasonProduct/updatePreliminaryKJ', {
        id: info.id,
        finishState: info.finishState || 0
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('提交成功')
          this.getTimeLine()
        } else {
          this.$message.error((res && res.msg) || '提交失败')
        }
      }).catch(() => {
        this.$message.error('提交失败')
      })
    },

    /**
     * 上传成功：res.code === 200 且 res.data 为文件链接，按字段名 push 到数组
     */
    onUploadSuccess (res, field) {
      if (res && res.code === 200 && res.data) {
        this.uploadFiles[field].push(res.data)
      } else {
        this.$message.error((res && res.msg) || '上传失败')
      }
    },
    /**
     * 删除已上传文件：从对应数组移除该链接
     */
    removeFile (url, field) {
      this.uploadFiles[field] = this.uploadFiles[field].filter(u => u !== url)
    },
    /**
     * 下载文件（图片/PDF/PPT 均可）：以 a 标签触发浏览器下载
     */
    downloadFile (url) {
      if (!url) return
      const a = document.createElement('a')
      a.href = url
      a.download = url.substring(url.lastIndexOf('/') + 1)
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    /**
     * 预览图片：打开大图对话框
     */
    previewImage (url) {
      this.previewUrl = url
      this.previewVisible = true
    },
    /**
     * 图片上传前校验（LOGO/海报/天头地尾）
     */
    beforeAvatarUpload (file) {
      const isImage = file.type.indexOf('image/') === 0
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isImage) {
        this.$message.error('只能上传图片文件!')
      }
      if (!isLt10M) {
        this.$message.error('图片大小不能超过 10MB!')
      }
      return isImage && isLt10M
    },
    /**
     * 设计部：提交（Slogan / LOGO / 海报 / 天头地尾 / PPT模板）
     * 四个文件字段均为链接数组，转 JSON 字符串传入
     * id: selectSupplementInfo 当前部门返回的主键 id
     */
    updateStartSj () {
      const sjDeptId = (this.deptSection.find(d => d.wildcard === 'SJB') || {}).id
      const info = this.supplementInfo[sjDeptId]
      if (!info || !info.id) {
        this.$message.warning('数据未加载，请稍后重试')
        return
      }
      this.$http.post('seasonProduct/updateStartSj', {
        id: info.id,
        slogan: this.form.slogan,
        logo: JSON.stringify(this.uploadFiles.logo),
        poster: JSON.stringify(this.uploadFiles.poster),
        docxTemplate: JSON.stringify(this.uploadFiles.docxTemplate),
        pptTemplate: JSON.stringify(this.uploadFiles.pptTemplate)
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('提交成功')
          this.getTimeLine()
        } else {
          this.$message.error((res && res.msg) || '提交失败')
        }
      }).catch(() => {
        this.$message.error('提交失败')
      })
    },
    /**
     * 交付中心：提交进校文件
     * entryDocuments: 进校文件链接数组转 JSON 字符串
     * id: selectSupplementInfo 当前部门返回的主键 id（获取方式同科技部）
     */
    updateStartXx () {
      const jfzxDeptId = (this.deptSection.find(d => d.wildcard === 'JFZX') || {}).id
      const info = this.supplementInfo[jfzxDeptId]
      if (!info || !info.id) {
        this.$message.warning('数据未加载，请稍后重试')
        return
      }
      this.$http.post('seasonProduct/updateStartXx', {
        id: info.id,
        entryDocuments: JSON.stringify(this.uploadFiles.entryDocuments)
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('提交成功')
          this.getTimeLine()
        } else {
          this.$message.error((res && res.msg) || '提交失败')
        }
      }).catch(() => {
      }).catch(() => {
        this.$message.error('提交失败')
      })
    },

    /**
     * 交付中心：城市初选 - 项目手册文案
     * 接口：seasonProduct/updatePreliminaryJfzx
     * id: selectSupplementInfo 当前部门返回的主键 id
     * preliminaryManual: 项目手册文案文件链接数组
     */
    updatePreliminaryJfzx () {
      const jfzxDeptId = (this.deptSection.find(d => d.wildcard === 'JFZX') || {}).id
      const info = this.supplementInfo[jfzxDeptId]
      if (!info || !info.id) {
        this.$message.warning('数据未加载，请稍后重试')
        return
      }
      this.$http.post('seasonProduct/updatePreliminaryJfzx', {
        id: info.id,
        preliminaryManual: JSON.stringify(this.uploadFiles.preliminaryManual)
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('提交成功')
          this.getTimeLine()
        } else {
          this.$message.error((res && res.msg) || '提交失败')
        }
      }).catch(() => {
        this.$message.error('提交失败')
      })
    },

    // ===== 其余部门上传提交：接口名 / 字段名均为占位，待后端确认后替换 =====
    // 学术 XSB - 初选（初赛试卷 + 初赛音频）
    updateStartYyxs1 () {
      // TODO: 接口名占位 seasonProduct/updateStartYyxs1
      const deptId = (this.deptSection.find(d => d.wildcard === 'XSB') || {}).id
      const info = this.supplementInfo[deptId]
      if (!info || !info.id) { this.$message.warning('数据未加载，请稍后重试'); return }
      this.$http.post('seasonProduct/updatePreliminaryXs', {
        id: info.id,
        preliminaryPaper: JSON.stringify(this.uploadFiles.preliminaryPaper),
        preliminaryAudio: JSON.stringify(this.uploadFiles.preliminaryAudio)
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('提交成功')
          this.getTimeLine()
        } else {
          this.$message.error((res && res.msg) || '提交失败')
        }
      }).catch(() => { this.$message.error('提交失败') })
    },
    // 学术 XSB - 复选（复赛试卷 + 裁判纸）
    updateStartYyxs2 () {
      // TODO: 接口名占位 seasonProduct/updateStartYyxs2
      const deptId = (this.deptSection.find(d => d.wildcard === 'XSB') || {}).id
      const info = this.supplementInfo[deptId]
      if (!info || !info.id) { this.$message.warning('数据未加载，请稍后重试'); return }
      this.$http.post('seasonProduct/updateStartYyxs2', {
        id: info.id,
        yyxsrematchExam: JSON.stringify(this.uploadFiles.yyxsrematchExam),
        yyxsrefereePaper: JSON.stringify(this.uploadFiles.yyxsrefereePaper)
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('提交成功')
          this.getTimeLine()
        } else {
          this.$message.error((res && res.msg) || '提交失败')
        }
      }).catch(() => { this.$message.error('提交失败') })
    },
    // 学术 XSB - 城市/网络选（城市赛考题）
    updateStartYyxs3 () {
      // TODO: 接口名占位 seasonProduct/updateStartYyxs3
      const deptId = (this.deptSection.find(d => d.wildcard === 'XSB') || {}).id
      const info = this.supplementInfo[deptId]
      if (!info || !info.id) { this.$message.warning('数据未加载，请稍后重试'); return }
      this.$http.post('seasonProduct/updateStartYyxs3', {
        id: info.id,
        yyxscityExam: JSON.stringify(this.uploadFiles.yyxscityExam)
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('提交成功')
          this.getTimeLine()
        } else {
          this.$message.error((res && res.msg) || '提交失败')
        }
      }).catch(() => { this.$message.error('提交失败') })
    },
    // 学术 XSB - 全国总决选（上传考题）
    updateStartYyxs4 () {
      // TODO: 接口名占位 seasonProduct/updateStartYyxs4
      const deptId = (this.deptSection.find(d => d.wildcard === 'XSB') || {}).id
      const info = this.supplementInfo[deptId]
      if (!info || !info.id) { this.$message.warning('数据未加载，请稍后重试'); return }
      this.$http.post('seasonProduct/updateStartYyxs4', {
        id: info.id,
        yyxsfinalsExam: JSON.stringify(this.uploadFiles.yyxsfinalsExam)
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('提交成功')
          this.getTimeLine()
        } else {
          this.$message.error((res && res.msg) || '提交失败')
        }
      }).catch(() => { this.$message.error('提交失败') })
    },
    // 设计 SJB - 初选（试卷模板）
    updateStartSjb1 () {
      // TODO: 接口名占位 seasonProduct/updateStartSjb1
      const deptId = (this.deptSection.find(d => d.wildcard === 'SJB') || {}).id
      const info = this.supplementInfo[deptId]
      if (!info || !info.id) { this.$message.warning('数据未加载，请稍后重试'); return }
      this.$http.post('seasonProduct/updatePreliminarySj', {
        id: info.id,
        preliminaryPaperTemplate: JSON.stringify(this.uploadFiles.preliminaryPaperTemplate)
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('提交成功')
          this.getTimeLine()
        } else {
          this.$message.error((res && res.msg) || '提交失败')
        }
      }).catch(() => { this.$message.error('提交失败') })
    },
    // 设计 SJB - 复选（试卷模板）
    updateStartSjb2 () {
      // TODO: 接口名占位 seasonProduct/updateStartSjb2
      const deptId = (this.deptSection.find(d => d.wildcard === 'SJB') || {}).id
      const info = this.supplementInfo[deptId]
      if (!info || !info.id) { this.$message.warning('数据未加载，请稍后重试'); return }
      this.$http.post('seasonProduct/updateStartSjb2', {
        id: info.id,
        sjbrematchTemplate: JSON.stringify(this.uploadFiles.sjbrematchTemplate)
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('提交成功')
          this.getTimeLine()
        } else {
          this.$message.error((res && res.msg) || '提交失败')
        }
      }).catch(() => { this.$message.error('提交失败') })
    },
    // 设计 SJB - 城市/网络选（上传备品）
    updateStartSjb3 () {
      // TODO: 接口名占位 seasonProduct/updateStartSjb3
      const deptId = (this.deptSection.find(d => d.wildcard === 'SJB') || {}).id
      const info = this.supplementInfo[deptId]
      if (!info || !info.id) { this.$message.warning('数据未加载，请稍后重试'); return }
      this.$http.post('seasonProduct/updateStartSjb3', {
        id: info.id,
        sjbcitySpare: JSON.stringify(this.uploadFiles.sjbcitySpare)
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('提交成功')
          this.getTimeLine()
        } else {
          this.$message.error((res && res.msg) || '提交失败')
        }
      }).catch(() => { this.$message.error('提交失败') })
    },
    // 设计 SJB - 全国总决选（上传备品）
    updateStartSjb4 () {
      // TODO: 接口名占位 seasonProduct/updateStartSjb4
      const deptId = (this.deptSection.find(d => d.wildcard === 'SJB') || {}).id
      const info = this.supplementInfo[deptId]
      if (!info || !info.id) { this.$message.warning('数据未加载，请稍后重试'); return }
      this.$http.post('seasonProduct/updateStartSjb4', {
        id: info.id,
        sjbfinalsSpare: JSON.stringify(this.uploadFiles.sjbfinalsSpare)
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('提交成功')
          this.getTimeLine()
        } else {
          this.$message.error((res && res.msg) || '提交失败')
        }
      }).catch(() => { this.$message.error('提交失败') })
    },
    scheduleStartFn () {
      this.$confirm('确认启动当前阶段吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const flag = this.steps[this.chooseIndex].scheduleFlag
        this.$http.post('seasonProduct/openSchedule', { scheduleFlag: flag, seasonProductId: this.id }).then(res => {
          if (res.code === 200) {
            this.getTabList()
            this.getTimeLine()
          }
        })
      }).catch(() => {})
    }
  }
}
</script>
<style scoped lang="less">
.page-title{
  font-size: 20px;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin: 10px 0;
}
.page-current{
  font-size: 12px;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin: 10px auto 30px;
  padding: 4px 30px 4px 20px;
  background-color: #f9d64a;
  width: fit-content;
  border-radius: 20px;
}
/* 上传加号卡片（替代原 picture-card，因改用自定义列表渲染） */
::v-deep .upload-demo .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  width: 108px;
  height: 108px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #8c939d;
  font-size: 28px;
  &:hover {
    border-color: #409EFF;
  }
}
/* 已上传图片列表：缩略图 + hover 遮罩（下载/预览/删除） */
.img-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}
.img-item {
  position: relative;
  width: 108px;
  height: 108px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #ebeef5;
  .img-thumb {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .img-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s;
    i {
      color: #fff;
      font-size: 20px;
      margin: 0 6px;
      cursor: pointer;
    }
  }
  &:hover .img-mask {
    opacity: 1;
  }
}
/* 已上传文件列表（PPT 等）：整行点击下载 */
.file-list {
  margin-top: 8px;
  .file-item {
    display: flex;
    align-items: center;
    padding: 8px 10px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    margin-bottom: 6px;
    cursor: pointer;
    transition: background 0.2s;
    &:hover {
      background: #f5f7fa;
    }
    .file-name {
      flex: 1;
      margin: 0 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .el-icon-download {
      color: #409EFF;
    }
    .el-icon-delete {
      color: #f56c6c;
      cursor: pointer;
      margin-left: 4px;
      &:hover {
        opacity: 0.7;
      }
    }
  }
}
.schedule-title{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .tit{
    font-size: 14px;
    font-weight: bold;
    color: #000;
    border-bottom: 3px solid #3f50f0;
    margin-left: 24px;
    padding-right: 20px;
  }
}
.tip{
  font-size: 12px;
  color: #666;
  text-align: center;
  margin-top: 6px;
}
.footer{
  .fabu{
    background-color: #4096ff;
    color: #fff;
    width: 300px;
    height: 46px;
    margin: 30px auto 20px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    line-height: 46px;
    border-radius: 6px;
    cursor: pointer;
    &:hover{
      box-shadow: 0 0 10px rgba(64, 150, 255, .5);
    }
  }
}

.progress-steps-row {
    display: flex;
    width: 100%;
    margin-bottom: 20px;
  }

  .step-col {
    cursor: pointer;
    flex: 1;
    position: relative;
    // 卡片之间留空隙
    &:not(:first-child) {
      margin-left: -5px;
    }

    .step-inner {
      background: #fff;
      padding: 10px 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    // ========= Step 标签 =========
    .step-row {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .step-label {
      display: flex;
      align-items: center;
      gap: 6px;
      margin-bottom: 6px;

      .step-label-text {
        font-size: 15px;
        color: #909399;
        font-weight: 600;
      }
      .step-label-check {
        font-size: 14px;
        color: #36b34a;
        font-weight: bold;
      }
    }

    // ========= 第一个：左直边，右侧向外斜凸（尖角朝右） =========
    .step-inner.first {
      clip-path: polygon(
        0 0,
        calc(100% - 16px) 0,
        100% 50%,
        calc(100% - 16px) 100%,
        0 100%
      );
    }

    // ========= 中间区块：【左侧向外凸、右侧向外凸】斜边完全平行！重点修复 =========
    .step-inner:not(.first):not(.last) {
      clip-path: polygon(
        0 0,
        calc(100% - 16px) 0,
        100% 50%,
        calc(100% - 16px) 100%,
        0 100%,
        16px 50%
      );
    }

    // ========= 最后一块：左侧向外凸，右直边 =========
    .step-inner.last {
      clip-path: polygon(
        0 0,
        100% 0,
        100% 100%,
        0 100%,
        16px 50%
      );
    }

    .step-circle {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      background: #c0c4cc;
      margin-bottom: 8px;
      flex-shrink: 0;
      margin-left: 5px;
    }

    .step-title {
      font-size: 16px;
      color: #1f30c7;
      font-weight: 500;
      margin-bottom: 4px;
      line-height: 1.4;
      padding: 6px 0 4px;
      i{
        margin-right: 6px;
        font-size: 18px;
      }
    }
    .step-desc {
      font-size: 12px;
      color: #666;
      line-height: 1.4;
    }
    .step-date{
      font-size: 12px;
      color: #666;
      padding-bottom: 4px;
    }

    // 状态颜色
    &.step-finish {
      .step-title {
        color: #000;
      }
      .step-inner{
        background: #f9d64a;
      }
    }
    &.step-choose{
      .step-title{
        color: #000;
      }
      .step-inner{
        background: #dee0fd;
      }
    }
    &.step-current {
      .step-title {
        color: #000;
        font-weight: bold;
      }
      .step-inner{
        background: linear-gradient(140deg, #f9d64a, #fdf4ce);
      }
    }
    &.step-pending {
      .step-title {
        color: #777;
      }
      .step-desc {
        color: #909399;
      }
    }
  }
  .desc{
    color: #666;
    font-size: 12px;
    margin-bottom: 14px;
  }

.time-line {
  position: relative;
  padding: 10px 0 20px 30px;
}
.time-line::before {
  content: '';
  position: absolute;
  left: 8px;
  top: 18px;
  bottom: 18px;
  width: 2px;
  background: #6b79f7;
}
.time-line-item {
  position: relative;
  margin-bottom: 24px;
  display: flex;
  align-items: flex-start;
}
.time-line-item:last-child {
  margin-bottom: 0;
}
.time-dot {
  position: absolute;
  left: -26px;
  top: 36px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #3f50f0;
  border: 1px solid #fff;
  box-shadow: 0 0 0 2px #3f50f0;
}
.time-content {
  background: #f5f7fa;
  // border-radius: 6px;
  padding: 10px 16px;
  flex: 1;
  // border-left: 3px solid #3f50f0;
}
.time-s {
  font-size: 12px;
  font-weight: bold;
  color: #000;
  background-color: #FAD54A;
  margin-bottom: 4px;
  padding: 4px 10px;
  border-radius: 12px 12px 12px 0;
  width: fit-content;
}
.time-date {
  font-size: 16px;
  font-weight: bold;
  color: #3f50f0;
  margin-bottom: 4px;
}
.time-dept{
  background-color: #3f50f0;
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  width: fit-content;
  font-size: 12px;
  margin: 8px 0;
}
.time-person {
  font-size: 12px;
  color: #606266;
  margin-bottom: 2px;
}
.time-event {
  font-size: 14px;
  color: #000;
  margin: 8px 0;
}
.save-btn{
  display: block;
  margin: 0 auto;
}

.start-btn{
  width: 180px;
  height: 46px;
  text-align: center;
  line-height: 46px;
  background: #aab2fd;
  color: #1826a2;
  font-weight: bold;
  border-radius: 8px;
  margin: 0 auto 20px;
  cursor: pointer;
  padding-right: 10px;
  i{
    margin-right: 10px;
  }
  &:hover{
    box-shadow: 0 0 10px rgba(11, 23, 124, 0.5);
  }
}
.dept-name{
  background: linear-gradient(140deg, #97a0f8, #fff);
  color: #1826a2;
  padding: 6px 0;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
.card /deep/ .el-card__body {
  padding: 0;
}
/deep/ .card.el-card{
  border-radius: 0;
}
</style>
